<template>
    <transition @after-leave="handleAfterLeave">
        <div class="yd-prompt__wrapper" v-if="visible">
            <div class="yd-prompt">
                <div class="yd-prompt__header">
                    <div class="yd-prompt__title">{{title}}</div>
                    <button type="button" class="yd-prompt__close" v-if="showClose" @click="close"></button>
                </div>
                <div class="yd-prompt__content" v-html="message"></div>
                <div class="yd-prompt__btns">
                    <button :style="{'color': cancelColor || '#3A3F49'}"
                        @click="btnHandler(false)"
                        v-pressed
                        v-if="showCancel"
                    >{{cancelText || '取消'}}</button>
                    <button :style="{'color': confirmColor || '#7AD21A'}"
                        @click="btnHandler(true)"
                        v-pressed
                    >{{confirmText || '确认'}}</button>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
export default {
    data(){
        return {
            visible: false,
            title: "",
            message: "",
            cancelText: "",
            cancelColor: "",
            showCancel: false,
            confirmColor: "",
            confirmText: "",
            showClose: false,
            onCallback: null
        }
    },
    methods:{
        handleAfterLeave() {
            this.$destroy(true);
            this.$el.parentNode.removeChild(this.$el);
        },
        close(){
            this.visible = false;
        },
        btnHandler(confirm){
            if (typeof this.onCallback === 'function') {
                this.onCallback(confirm);
            }
            this.close();
        }
    }

}
</script>
 <style lang="scss" scoped>
.yd-prompt__wrapper{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0,0,0,0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    .yd-prompt{
        width: 630px;
        height: auto;
        background: #FFFFFF;
        box-shadow: 0px 12px 40px -8px rgba(136,136,136,0.25);
        border-radius: 20px;
        box-sizing: border-box;
        overflow: hidden;
        .yd-prompt__header{
            height: 92px;
            width: 100%;
            padding: 48px 20px 0;
            box-sizing: border-box;
            position: relative;
            .yd-prompt__title{
                width: 100%;
                height: 44px;
                font-size: 32px;
                color: #1B1C1E;
                text-align: center;
                font-weight: 500;
                line-height: 44px;
            }
            .yd-prompt__close{
                width: 48px;
                height: 48px;
                position: absolute;
                top: 16px;
                right: 16px;
                @include bg-image("../../assets/images/icon/icon_dialog_close");
                background-size: 100% 100%;
            }
        }
        .yd-prompt__content{
            width: 100%;
            min-height: 124px;
            padding: 24px 30px;
            box-sizing: border-box;
            font-size: 28px;
            color: #3A3F49;
            text-align: center;
            line-height: 44px;
            font-weight: 400;
        }
        .yd-prompt__btns{
            width: 100%;
            height: 90px;
            display: flex;
            button{
                flex: 1;
                height: 90px;
                font-size: 28px;
                color: #3A3F49;
                text-align: center;
                font-weight: 500;
                line-height: 90px;
                border-top: 1px solid #EFEFEF;
                border-right: 1px solid #EFEFEF;
                box-sizing: border-box;
                &.pressed{
                    background: rgba(0,0,0,0.05);
                }
                &:last-of-type{
                    border-right: none;
                }
            }
        }
    }
}
 </style>